<template>
  <div class="portfolio">

    <section class="portfolio-head">
      <b-row>
        <b-col md="8" offset-md="2">
          <img src="../../assets/projects/nals/NALS_android_splash.png" alt="" class="portfolio-icon">
          <h1>
            NALS - Trend Micro's leave system app
          </h1>
          <p>
            NALS or North America Leave System is an internal app of Trend Micro that helps employee to file a leave easily on their mobile device. It also have a monitoring list to track their filed leave if its approved or not.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <img src="../../assets/projects/nals/banner.png" alt="" class="clickable" v-viewer>
        </b-col>
      </b-row>
    </section>

    <section>
      <b-row>
        <b-col>
          <h3>About the project</h3>
          <p>In Trend Micro employee’s safety, health and family are important to the company’s culture that whenever an employee needs time for there family or personal agenda Trend Micro’s allow them to take some leaves. But with the previous system there are always a delay when ever an employee’s file a leave of absent to inform and be approved by there manager. Specially to those who work remotely like sales and marketing connecting to VPN just to file a leave is hideous</p>
          <p>My task is to design a new process that will make the filling of leave more accessible, easy and can be monitor both the employee and their manager.</p>
        </b-col>
      </b-row>
    </section>

    <section>
      <b-row>
        <b-col>
          <h3>Solution</h3>
          <p>As I employee of Trend Micro who also file leave I know how hard the process just to file and inform my manager. Since majority of leave are filed remotely we need to create a mobile app that employees can be access even without VPN and have simplified process.</p>
          <p>The process will like just sending a message to the manager and rather than using the old forms employee just need to fill out the Date and the Reason of leave which make it more personal.</p>
          <p>The app also shows the status of the leave and integrated with the employee’s team it has a calendar that shows their team members leave to help them plan ahead if needed.</p>
        </b-col>
      </b-row>
    </section>

    <section>
      <b-row>
        <b-col>
          <h3>Features</h3>
          <img src="../../assets/projects/nals/nals-1.jpg" alt="" class="clickable" v-viewer>
          <img src="../../assets/projects/nals/nals-2.jpg" alt="" class="clickable" v-viewer>
          <img src="../../assets/projects/nals/nals-3.jpg" alt="" class="clickable" v-viewer>
        </b-col>
      </b-row>
    </section>

    <section>
      <b-row>
        <b-col>
          <h3>Visual Design</h3>
          <img src="../../assets/projects/nals/caren-dribbble.gif" alt="" class="clickable" v-viewer>
          <img src="../../assets/projects/nals/error_message.gif" alt="" class="clickable" v-viewer>
          <img src="../../assets/projects/nals/nals-app-icon.jpg" alt="" class="clickable" v-viewer>
          <img src="../../assets/projects/nals/nals-screens.jpg" alt="" class="clickable" v-viewer>
        </b-col>
      </b-row>
    </section>

    <section class="portfolio-referrence">
      <b-row>
        <b-col>
          <div>
            <span class="label">Links</span><br>
            <ul class="list-unstyled">
              <li>
                NALS iOS: <a href="https://invis.io/9Y2ZELQE6">https://invis.io/9Y2ZELQE6</a>
              </li>
              <li>
                NALS Android: <a href="https://invis.io/9H2ZDWZJP">https://invis.io/9H2ZDWZJP</a>
              </li>
            </ul>
          </div>
          <div>
            <span class="label">Tool Used</span>
            <ul class="tools">
              <li>
                <i class="devicon-photoshop-plain" v-b-tooltip title="Adobe Photoshop"></i>
              </li>
              <li>
                <i class="devicon-illustrator-plain" v-b-tooltip title="Adobe Illustrator"></i>
              </li>
              <li>
                <i class="devicon-android-plain" v-b-tooltip title="Android Material Design Guidelines"></i>
              </li>
              <li>
                <i class="devicon-apple-plain" v-b-tooltip title="iOS Human Interface Guidelines"></i>
              </li>
            </ul>
          </div>
          <div>
            <span class="label">Category</span>
            <ul class="tags">
              <li>UI/UX</li>
              <li>Product Design</li>
              <li>Illustration</li>
              <li>Information Architecture</li>
            </ul>
          </div>
        </b-col>
      </b-row>
    </section>
    <section class="portfolio-bottom">
      <b-row>
        <b-col>
          <b-link to="/">
            View more project
          </b-link>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'Portfolio'
  }
</script>



// WEBPACK FOOTER //
// src/views/Works/Nals.vue